<!-- prettier-ignore -->

<div (click)="closeModal()" class="add-sub-interest-header">
    <span>{{'Selecciona Subcategoría' | translate }}</span>
    <span>X</span>
</div>

<div class="add-sub-interest-body">

    <div class="subcategories-wrapper">
        <label class="checkbox-image">
            @if(tools.isDistributor){
                <input type="checkbox" 
                    [value]="category.ids" 
                    (focusin)="focusin($event)" 
                    (change)="setCategory()"
                >
            }
            @if(tools.isApp || isRegisterStandaloneApp){
                <input type="checkbox" 
                    [value]="category.id" 
                    (focusin)="focusin($event)" 
                    (change)="setCategory()"
                >
            }
            <div class="img-container">
                <div class="img-wrapper" [ngClass]="{
                    'selectedRegister': category.selected && !isAnySubcategorySelected(),
                    'setOpacity': !category.selected || isAnySubcategorySelected()
                }" >
                    <cicerone-lazy-image 
                        [url]="category.image" 
                        [urlFallback]="category.imageFallback" 
                        [altImage]="category.name?.[translate.currentLang]" 
                    />
                </div>
            </div>
            <span class="subcategory-title">{{ 'Todos' | translate }}</span>
        </label>
    </div>
    
    @for(item of category.subcategories; track $index) {
        <div class="subcategories-wrapper">
            <label class="checkbox-image">
                @if(tools.isDistributor){
                    <input type="checkbox" [value]="item.ids" (focusin)="focusin($event)" (change)="setSelectedOption(item)">

                }
                @if(tools.isApp || isRegisterStandaloneApp){
                    <input type="checkbox" 
                        [value]="item.id" 
                        (focusin)="focusin($event)" 
                        (change)="setSelectedOption(item)"
                    >
                }
                <div class="img-container">
                    <div class="img-wrapper" [ngClass]="{
                        'selectedRegister': item.selected,
                        'setOpacity': !item.selected
                    }" >
                        <cicerone-lazy-image 
                            [url]="item.image" 
                            [urlFallback]="item.imageFallback" 
                            [altImage]="item.name?.[translate.currentLang]" 
                        />
                    </div>
                </div>
                <span class="subcategory-title">{{ item.name?.[translate.currentLang] }}</span>
            </label>
        </div>
    }

</div>
